module.exports = __webpack_public_path__ + "img/zoom-plus.e370a538.svg";